(() => {
  if (window.leeanneStockPriority) return;
  window.leeanneStockPriority = true;
  const started = new WeakSet();
  const running = new Map();

  const partition = (items) => [
    ...items.filter((item) => item.dataset.productAvailable === 'true'),
    ...items.filter((item) => item.dataset.productAvailable !== 'true'),
  ];

  async function arrange(grid) {
    const pages = Number(grid.dataset.stockPages);
    if (pages < 2) return;
    const currentPage = Number(grid.dataset.stockPage);
    const pageSize = Number(grid.dataset.stockPageSize);
    const section = grid.dataset.stockSection;
    const pageParam = grid.dataset.stockPageParam || 'page';
    const context = location.pathname + location.search;
    const controller = new AbortController();
    running.set(grid, controller);
    grid.setAttribute('aria-busy', 'true');
    try {
      const results = new Array(pages);
      results[currentPage - 1] = Array.from(grid.children);
      const pending = Array.from({ length: pages }, (_, index) => index + 1)
        .filter((page) => page !== currentPage);
      let cursor = 0;
      await Promise.all(Array.from({ length: Math.min(3, pending.length) }, async () => {
        while (cursor < pending.length) {
          const page = pending[cursor++];
          const url = new URL(location.href);
          url.searchParams.delete('sections');
          url.searchParams.set('section_id', section);
          url.searchParams.set(pageParam, String(page));
          const response = await fetch(url, {
            signal: controller.signal,
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Collection page unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const otherGrid = doc.querySelector('#product-grid[data-stock-priority="true"]');
          if (!otherGrid || otherGrid.dataset.stockSection !== section) {
            throw new Error('Collection changed during sorting');
          }
          results[page - 1] = Array.from(otherGrid.children);
        }
      }));
      if (!grid.isConnected || context !== location.pathname + location.search) return;
      const allItems = results.flat();
      const ids = new Set();
      for (const item of allItems) {
        const id = item.dataset.productId;
        if (!id || ids.has(id)) throw new Error('Collection changed during sorting');
        ids.add(id);
      }
      const start = (currentPage - 1) * pageSize;
      const items = partition(allItems).slice(start, start + pageSize);
      if (items.length !== grid.children.length) throw new Error('Collection changed during sorting');
      const cards = items.map((item) => {
        const card = item.cloneNode(true);
        card.classList.remove('scroll-trigger', 'animate--slide-in');
        return card;
      });
      const focusedId = grid.contains(document.activeElement)
        ? document.activeElement.id : null;
      grid.replaceChildren(...cards);
      if (focusedId) document.getElementById(focusedId)?.focus({ preventScroll: true });
      grid.dataset.stockSorted = 'true';
    } catch (error) {
      controller.abort();
    } finally {
      grid.removeAttribute('aria-busy');
      running.delete(grid);
    }
  }

  function scan() {
    for (const [grid, controller] of running) {
      if (!grid.isConnected) controller.abort();
    }
    document.querySelectorAll('#product-grid[data-stock-priority="true"]').forEach((grid) => {
      if (started.has(grid)) return;
      started.add(grid);
      arrange(grid);
    });
  }

  function start() {
    scan();
    const root = document.getElementById('MainContent');
    if (!root) return;
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; scan(); });
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
